'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cache = require('./cache');

var _cache2 = _interopRequireDefault(_cache);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var cacheStorage = new _cache2.default();
var cacheMiddleware = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ctx, next) {
        var req, enableCache, cacheConfig, responseAdapter, originUrl, params, reqCache;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        req = ctx.req;
                        enableCache = req.externals.enableCache || false;

                        if (!(req.method !== 'GET' || !enableCache)) {
                            _context.next = 6;
                            break;
                        }

                        _context.next = 5;
                        return next();

                    case 5:
                        return _context.abrupt('return');

                    case 6:
                        cacheConfig = req.externals.cacheConfig || {};

                        responseAdapter = cacheConfig.responseAdapter || function () {
                            return true;
                        };

                        originUrl = req.originUrl;
                        params = req.data;
                        reqCache = cacheStorage.getCache(originUrl, params, cacheConfig);

                        if (!reqCache) {
                            _context.next = 15;
                            break;
                        }

                        ctx.generateResponse({
                            status: 200,
                            statusText: 'from cache',
                            body: reqCache
                        });
                        _context.next = 18;
                        break;

                    case 15:
                        _context.next = 17;
                        return next();

                    case 17:
                        if (!!ctx.res.ok && !!responseAdapter(ctx.res.body)) {
                            cacheStorage.setCache(originUrl, params, ctx.res.body, cacheConfig);
                        }

                    case 18:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function cacheMiddleware(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

exports.default = cacheMiddleware;